// TypeScript 版本的 SET_STATE 辅助函数
export const SET_STATE = <T extends Record<string, any>>(
    state: T,
    payload: Partial<T>
): void => {
    Object.keys(payload).forEach(key => {
        state[key as keyof T] = payload[key as keyof T];
    });
};
